// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dracozolt: PokeData = {
  "id": 880,
  "name": "dracozolt",
  "height": 18,
  "weight": 1900,
  "base_experience": 177,
  "types": [
    PokeType.ELECTRIC,
    PokeType.DRAGON
  ],
  "api_moves": [
    "slam",
    "stomp",
    "tackle",
    "thunder-shock",
    "ancient-power",
    "charge",
    "aerial-ace",
    "pluck",
    "dragon-pulse",
    "dragon-rush",
    "discharge",
    "dragon-tail",
    "bolt-beak"
  ],
  "moves": [
    "tackle",
    "thunder-shock",
    "ancient-power",
    "aerial-ace",
    "dragon-pulse",
    "dragon-rush",
    "dragon-fang",
    "dragon-vortex",
    "great-roar",
    "inner-spirit",
    "volt-crash",
    "electric-terrain",
    "volt-switch"
  ],
  "evolution_chain": {
    "id": 461,
    "item": null,
    "species": [
      {
        "name": "dracozolt",
        "order": 880,
        "types": [
          PokeType.ELECTRIC,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 131,
    "speed": 115,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
